// extracted by mini-css-extract-plugin
module.exports = {"icon":"Banner-module__icon___ycu35","icon--no-title":"Banner-module__icon--no-title___ZzOiv","text":"Banner-module__text___PNz6y","title":"Banner-module__title___n10Y-"};